import styles from './card.module.scss';
import cx from 'classnames';
import { MouseEventHandler } from 'react';

type BgType = 'green' | 'pink' | 'gray' | 'white';

export interface CardProps {
  children?: React.ReactElement;
  background?: BgType;
  className?: string;
  style?: any;
  onClick?: MouseEventHandler<HTMLDivElement>;
  backgroundImage?: string;
}

export const Card = (props: CardProps) => {
  const {
    children,
    background,
    className = '',
    onClick,
    style = {},
    backgroundImage,
  } = props;

  return (
    <div
      className={cx(
        styles['Card'],
        background && styles[background],
        onClick && styles['CardButton'],
        className
      )}
      style={style}
      onClick={onClick}
    >
      <>
        {backgroundImage ? (
          <div
            className={styles['BackgroundImage']}
            style={{ backgroundImage: `url(${backgroundImage}` }}
          >
            <div className={styles['Content']}>{children}</div>
          </div>
        ) : (
          <>{children}</>
        )}
      </>
    </div>
  );
};

export default Card;
